export default "__VITE_ASSET__KIktLKwa__"